module.exports = __webpack_public_path__ + "img/240.359e035c.jpg";